import { render } from "./UpdateMenuCategory.vue?vue&type=template&id=12639afd&scoped=true"
import script from "./UpdateMenuCategory.vue?vue&type=script&lang=js"
export * from "./UpdateMenuCategory.vue?vue&type=script&lang=js"

import "./UpdateMenuCategory.vue?vue&type=style&index=0&id=12639afd&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12639afd"]])

export default __exports__